import Api from "~/service/Api";

class TourRepository {
  getOne(tourId, query) {
    return Api.get(`/tours/${tourId}`, query);
  }

  fetch(query) {
    return Api.get("/tours", query);
  }

  create(data) {
    return Api.post("/tours", data);
  }

  fetchOne(tourId) {
    return Api.get(`/tours/${tourId}`);
  }

  update(tourId, data, locale = "en") {
    return Api.put(`/${locale}/tours/${tourId}`, data);
  }

  delete(tourId) {
    return Api.delete(`/tours/${tourId}`);
  }

  sendStats(tourId) {
    return Api.post(`/tour/statistics/notification/${tourId}`, {});
  }

  getTourStats(tourId) {
    return Api.get(`/tour/statistics/${tourId}`);
  }
}

export default TourRepository;
